import { EventEmitter } from "@angular/core";
import { PruHttpService } from "./pru-http.service";
import { AggregationService } from './aggregation.service';
import { SessionStorageService } from './web-storage/session-storage.service';
import * as i0 from "@angular/core";
import * as i1 from "./pru-http.service";
import * as i2 from "./aggregation.service";
import * as i3 from "./web-storage/session-storage.service";
//declare var environment: any;
var LinkService = /** @class */ (function () {
    function LinkService(_pruHttpService, _aggregationService, _sessionStorageService) {
        this._pruHttpService = _pruHttpService;
        this._aggregationService = _aggregationService;
        this._sessionStorageService = _sessionStorageService;
        this.linkBanner = false;
        this.hasGoals = true;
        this.linkBannerContent$ = null;
        this.goalsCheck = false;
        this.hideBanner = true;
        //showEngageB: boolean;
        this.linkEvent = new EventEmitter();
        //   this.showEngageB = false;
    }
    LinkService.prototype.getLinkGoals = function () {
        var url = "/api/co/secure/planning/v1/goals";
        return this._pruHttpService.get(url, "LinkService");
    };
    LinkService.prototype.triggerGoalsCheck = function () {
        var _this = this;
        this.subscription = this._aggregationService.aggregationDone.subscribe(function (res) {
            if (res && res === 'aggregationDone') {
                _this.subscription.unsubscribe();
                var goals = _this._sessionStorageService.getItem('userLinkGoals', true);
                if (goals) {
                    _this.checkForGoals(goals);
                }
                else {
                    _this.getLinkGoals().subscribe(function (res) {
                        _this._sessionStorageService.setItem('userLinkGoals', res, true);
                        _this.checkForGoals(res);
                    }, function (err) {
                        _this.linkEvent.emit('noGoals');
                        _this.hasGoals = false;
                        console.log("goals service Failure:", err);
                    });
                }
            }
        });
    };
    LinkService.prototype.checkForGoals = function (userGoals) {
        this.goalsCheck = true;
        this.hideBanner = false;
        if (userGoals.length > 0) {
            this.hasGoals = true;
            this.linkEvent.emit('hasGoals');
        }
        else {
            this.hasGoals = false;
            this.linkEvent.emit('noGoals');
        }
    };
    LinkService.ngInjectableDef = i0.defineInjectable({ factory: function LinkService_Factory() { return new LinkService(i0.inject(i1.PruHttpService), i0.inject(i2.AggregationService), i0.inject(i3.SessionStorageService)); }, token: LinkService, providedIn: "root" });
    return LinkService;
}());
export { LinkService };
